export default __webpack_public_path__ + "appointments/static/media/ashblonde.54fa83bd.png";